import { Button } from "@design";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { isRouteErrorResponse, useRouteError } from "react-router";
import { ApiError } from "@/api";
import { CenteredScreen } from "@/components/CenteredScreen";
import { Text } from "@/components/Text";
import { reportError } from "@/telemetry/telemetry";

/**
 * Route-level error boundary (errorElement). Catches render/loader errors
 * anywhere in the tree so one broken page never blanks the whole app.
 */
export function RouteErrorPage() {
  const error = useRouteError();
  const { t } = useTranslation(["errors", "common"]);
  useEffect(() => {
    console.error("Route error:", error);
    reportError(error, { source: "route" });
  }, [error]);
  const detail = isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : null;
  const requestId = error instanceof ApiError ? error.requestId : null;
  return (
    <CenteredScreen>
      <Text variant="h2" as="h1">
        {t("route.title")}
      </Text>
      <Text tone="secondary">{detail ?? t("route.message")}</Text>
      {requestId && (
        <Text variant="caption" tone="tertiary">
          {t("route.reference", { id: requestId })}
        </Text>
      )}
      <Button variant="secondary" onClick={() => globalThis.location.reload()}>
        {t("common:reload")}
      </Button>
    </CenteredScreen>
  );
}
